var render, staticRenderFns
import script from "./listAdmin.vue?vue&type=script&lang=js&"
export * from "./listAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3ae92",
  null
  
)

export default component.exports